module.exports = __webpack_public_path__ + "static/media/no-direct-reportees.b04d91f5.svg";